module.exports = __webpack_public_path__ + "static/media/036.bfea782c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/people/thumbs/036.jpg
// module id = 382
// module chunks = 0